import { Dispatch, SetStateAction } from 'react';

import { Radio, RadioGroup, Text } from '@thefarmersfront/kitchen';

import { Bullet, FormField } from '~/components/common';
import type { TypeLinkedInfoValue } from '~/pages/vender/confirm/VenderConfirmPage';

import styles from './VenderConfirmLinkedInfoSection.module.scss';

const VenderConfirmLinkedInfoSection = ({
  hasEditPermission,
  linkedInfoValue,
  setLinkedInfoValue,
}: {
  hasEditPermission: boolean;
  linkedInfoValue: TypeLinkedInfoValue;
  setLinkedInfoValue: Dispatch<SetStateAction<TypeLinkedInfoValue>>;
}) => {
  const disabled = !hasEditPermission;

  return (
    <div className={styles['section-container']}>
      {linkedInfoValue.nfaReturnExchangeLinkYn !== null && (
        <>
          <div className={styles['section-title-wrapper']}>
            <Text size="xxlarge" weight="bold" element="p">
              연동 정보
            </Text>
          </div>
          <div>
            <FormField
              label="네이버 반품, 교환 연동 여부"
              tooltip={{
                description: (
                  <div className={styles['tooltip-description-container']}>
                    <p className={styles['tooltip-row']}>
                      <Bullet fill="#ffffff" />
                      네이버 반품, 교환 관리에서 고객의 반품, 교환 상태를 조회할 수 있습니다.
                    </p>
                    <p className={styles['tooltip-row']}>
                      <Bullet fill="#ffffff" />
                      컬리의 계약 택배사 정보를 네이버 판매자 센터에 입력해야 합니다. 자세한 가이드는 컬리로 문의해
                      주세요.
                    </p>
                  </div>
                ),
              }}
              contents={
                <RadioGroup
                  name="naver-return-exchange-linked"
                  size="medium"
                  disabled={disabled}
                  value={linkedInfoValue.nfaReturnExchangeLinkYn === true ? 'Y' : 'N'}
                  onChange={(e) =>
                    setLinkedInfoValue((prev) => ({ ...prev, nfaReturnExchangeLinkYn: e.target.value === 'Y' }))
                  }
                >
                  <Radio value="Y" label="예" />
                  <Radio value="N" label="아니오" />
                </RadioGroup>
              }
              labelClassName={styles['input-row-label']}
              contentsClassName={styles['input-row-contents']}
            />
          </div>
        </>
      )}
    </div>
  );
};

export default VenderConfirmLinkedInfoSection;
